// Librerias
import React from 'react'
let PropTypes = React.PropTypes
// CSS
import * as css from './TablaArchivos.css'

export class RowArchivo extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    render(){
        return (
            <tr key={1}>
                <td>{this.props.correlativo}</td>
                <td className={css.tdNombre}>{this.props.archivo.cons_nombreOriginal}</td>
                <td className={css.tdTipo}>{this.props.archivo.cons_tipo==1?'IRD':'Vencimiento'}</td>
                <td className={css.tdUsuario}>{this.props.archivo.cons_subidoPor}</td>
                <td className={css.tdFecha}>{this.props.archivo.cons_created_at}</td>
                <td className={css.tdResultado}>{this.props.archivo.cons_resultado}</td>
                <td className={css.tdBoton}>{
                    <BotonDescarga
                        idArchivo={this.props.archivo.cons_id}
                    />    
                    }
                </td>
            </tr>
        )
    }
}
RowArchivo.propTypes = {
    archivo: PropTypes.object,
    correlativo: PropTypes.number
}
const BotonDescarga = ({idArchivo})=>
    <a className={'btn btn-md btn-success pull-right'}
       href={`/archivos/consolidado/${idArchivo}`}>
        Consolidado
    </a>


// WEBPACK FOOTER //
// ./frontEnd/auditorias/consolidados/RowArchivo.jsx